(function($) {
"use strict";

	var $window = $(window);
	var $slick_slider = $('.stories-slider');
	var settings = {
		adaptiveHeight: false,
		slide: ".stories-slide",
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide: 0,
		pauseOnHover: true,
		infinite: true,
		speed: 400,
		autoplay: true,
		autoplaySpeed: 10000,
		dots: true,
		appendDots: ".stories-navigation",
		dotsClass: "slick-dots stories-dots",
		arrows: true,
		appendArrows: ".stories-navigation",
		mobileFirst: true,
	};
	$slick_slider.slick(settings);

	$window.on('resize load', function() {
		if ($window.width() >= 768) {
			if ($slick_slider.hasClass('slick-initialized') )
				$slick_slider.slick('unslick');
			return;
		}
		if (!$slick_slider.hasClass('slick-initialized') )
			return $slick_slider.slick(settings);
	});

}(jQuery));
